"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const RedirectTo = ({ history, path }) => {
    history.push('/temp');
    history.replace(path);
};
exports.default = RedirectTo;
